import { memo } from 'react';
import { useToggle } from '../hooks/useToggle';
import { CategoryPublication } from '../api/category';
import { CategoryPublicationForm } from './PublicationFormCategory';
import { Option } from '../types/option';

type Props = {
    publication: CategoryPublication;
    categoryId: number;
    onPublicationSaved?: () => void;
};

export const CategoryPublicationCard = memo(
    ({ publication, categoryId, onPublicationSaved }: Props) => {
        const [isOpen, , handleToggle] = useToggle(false);

        return (
            <li className="w-full">
                <div className="overflow-hidden rounded-md bg-white shadow-md">
                    <div
                        className="flex cursor-pointer items-center justify-between gap-4 p-5"
                        onClick={handleToggle}
                    >
                        <p className="min-w-0 flex-1 text-medium font-medium text-dark-gray">
                            {publication.title}
                        </p>
                        <button
                            type="button"
                            className="card-expanded shrink-0"
                            aria-expanded={isOpen}
                        />
                    </div>
                    {isOpen && (
                        <div className="border-t border-light-gray bg-[#F2F2F2] p-4">
                            <CategoryPublicationForm
                                publication={Option.some(publication)}
                                categoryId={categoryId}
                                onPublicationSaved={onPublicationSaved}
                            />
                        </div>
                    )}
                </div>
            </li>
        );
    },
);
